import React from 'react';
import { CNavLink } from "./c/CHeader";
import CUserImageIcon from "../../CUserImageIcon";
import { useTranslations, useIsPremiumUser } from "examsbook-react-sdk/custom-hooks";
import { useSelector } from "react-redux";

/**
 * UserMenuList
 * @param props
 * @returns {*}
 * @constructor
 */
function UserMenuList(props) {
    const { user, openFeedbackModel } = props;
    const t = useTranslations();
    const appSettings = useSelector((state) => state.appSettings);
    const isPremium = useIsPremiumUser();
    let imageUrl;
    if (user && user.image) {
        imageUrl = user.image.thumbnail.webP;
    }
    const isPaymentEnabled = !!appSettings.paymentEnabled;

    function gotoPage(location, inNewTab = true) {
        if (inNewTab) {
            window.open(
                ('/' + location),
                '_blank'
            );
        } else {
            window.location = '/' + location;
        }
    }

    function logout() {
        window.location.href = '/logout';
    }

    return (
        <React.Fragment>
            <CUserImageIcon src={imageUrl}/>
            <ul className="sub-menus">
                <li><CNavLink to="/my-app/settings">{t('settings')}</CNavLink></li>
                {
                    isPaymentEnabled && !isPremium &&
                    <li><CNavLink to="/my-app/payments">{t('Access All tests')}</CNavLink></li>
                }
                {
                    isPaymentEnabled && <li><CNavLink to="/my-app/transactions">{t('Transactions')}</CNavLink></li>
                }
                <li onClick={() => {
                    gotoPage('change-password', false);
                }}>{t('change_password')}</li>
                <li onClick={openFeedbackModel.bind(this)}>{t('feedback')}</li>
                <li onClick={logout.bind(this)}>{t('logout')}</li>
            </ul>
        </React.Fragment>
    );
}

export default UserMenuList;
